<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-smart-tag-dashboard-table-detail-associated-phrase-hit" v-loading="loading">
    <div v-if="!showCategoriesContent||(topicPhraseHitsCategoriesList&&topicPhraseHitsCategoriesList.length>0)" class="main-panel-content">
      <div class="phrase-categories-section">
        <div class="div-phrase-categories-header div-group-name">
          Phrase categories
        </div>
        <div class="div-content" v-loading="loadingCategories">
          <div v-if="showCategoriesContent" class="div-phrase-categories categories">
            <div v-if="topicPhraseHitsCategoriesList&&topicPhraseHitsCategoriesList.length>0"  class="div-phrase-categories-content">
              <div v-for="(category, index) in topicPhraseHitsCategoriesList" :label="category.categoryName" :key="index"
                v-bind:class="{ 'div-item': true, selected: category && category.selected }"
                @click="getPhrasesByCategory(category, 0, $event)">
                <div :title="category.categoryName" class="div-ellipsis-item">{{ category.categoryName }}</div>
                <div class="div-total" @mouseover="mouseover($event, category.numberOfPhrases, '')" @mouseout="mouseout">({{ formatterNumber(category.numberOfPhrases) }})</div>
              </div>
            </div>
            <div v-else class="div-no-data"></div>
          </div>
        </div>
      </div>

      <div class="topic-group-section">
        <div class="div-phrases-header div-group-name">
          Phrases
        </div>
        <div class="div-content" v-loading="loadingPhrases">
          <div v-if="showPhraseContent" class="div-phrase-categories phrases" :class="{ 'no-data': topicPhraseHitsList&&topicPhraseHitsList.length == 0 }">
            <div v-if="topicPhraseHitsList&&topicPhraseHitsList.length>0" class="div-phrase-categories-content">
              <div v-for="(phrase, index) in topicPhraseHitsList" :label="phrase.phraseName" :key="index"
                v-bind:class="{ 'div-item': true, selected: phrase && phrase.selected }"
                @click="getContactsByCategoryPhrase(selectedCategory, phrase, 0, $event)">
                <div :title="phrase.phraseName" class="div-ellipsis-item">{{ phrase.phraseName }}</div>
                <div class="div-total" @mouseover="mouseover($event, phrase.numberOfContacts, '')" @mouseout="mouseout">({{ formatterNumber(phrase.numberOfContacts) }})</div>
              </div>
            </div>
            <div v-else class="div-no-data"></div>
          </div>
        </div>
      </div>

      <div class="smart-tag-contacts-section">
        <div class="div-smart-tag-contacts-header">Contact IDs</div>
          <div v-loading="loadingMsg" style="height: calc(100% - 60px);">
            <div v-if="showMessageContent" style="height:100%;">
              <div v-if="topicMessages&&topicMessages.length>0" class="div-smart-tag-contacts-content">
                <div ref="conversationMessages" class="div-topic-message-name" v-for="(item, index) in topicMessages" :key="index"
                  v-bind:class="{ selected: (selectedMessage && selectedMessage.conversationId == item.conversationId) }">
                  <div class="div-item-row">
                    <div class="col-left">
                      <div class="message-contact-id" @click="handleOpenMediaPlayer(item.conversationId)">{{ item.conversationId }}</div>
                      <div class="message-date">{{ formatMessageHeaderDate(item.startDateTime) }}</div>
                    </div>
                    <div class="col-right">
                      <div class="message-contact-name">{{ item.agentFirstName }} {{ item.agentLastName }}</div>
                      <div class="message-date-time">{{ getTimeRange(item) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="div-no-data">
                <div class="no-data-message"></div>
              </div>
              <div v-if="topicMessages&&topicMessages.length>0" class="div-smart-tag-contacts-footer div-group-name">
                <div class="div-message-transcripts-viewer-footer">
                  <div class="div-transcript-page-infor">Showing {{ pageItemStart }}-{{ pageItemEnd }}</div>
                  <div class="div-transcript-pagination">
                    <el-pagination :page-size="pageSize" :page-count="pageCount" :current-page="pageNo" :disabled="loadingMsg" prev-text="< Previous"
                      next-text="Next >" @current-change="pageChanged" layout="prev, next">
                    </el-pagination>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="main-panel div-no-data">
      <div class="no-data-message"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import WyUtils from '../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-smart-tag-dashboard-table-detail-associated-phrase-hit',
  props: ['parent', 'activeTab'],

  data() {
    return {
      loading: false,
      loadingCategories: false,
      loadingPhrases: false,
      loadingMsg: false,
      loadingTranscriptMsg: false,
      showCategoriesContent: false,
      showPhraseContent: false,
      initDate: null,
      topicPhraseHitsCategories: [],
      topicPhraseHits: [],
      tagData: {},
      topicMessages: [],
      selectedCategory: null,
      selectedMessage: null,
      updatedTimestamp: (new Date()).getTime(),

      showMessageContent: false,
      showTranscriptContent: false,

      pageNo: 1,
      pageSize: 1, // backend returns 0-99 (total 100)
      pageCount: 1,
      pageItemStart: 0,
      pageItemEnd: 0,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'isRoleAllow', 'processList', 'transcriptInfoReference', 'tokenInfo']),

    topicPhraseHitsCategoriesList() {
      return this.topicPhraseHitsCategories;
    },

    topicPhraseHitsList() {
      return this.topicPhraseHits;
    }
  },

  methods: {
    ...mapActions(['fetchAssociatedTopicPhraseHitCategories', 'fetchAssociatedTopicPhraseHitByCategoryName', 'fetchContactReasonsTopicConversationDetail', 'fetchAssociatedTopicPhraseHitContacts']),
    ...mapMutations(['updateTranscriptInfoReference']),

    pageChanged(pageNo) {
      const selectedTopic = this.topicPhraseHitsList.find(el => el && el.selected);
      if (selectedTopic) {
        this.getContactsByCategoryPhrase(this.selectedCategory, selectedTopic, pageNo);
      }
    },

    handleTimeInNiceFormat(Millis) {
      let seconds = Millis / 1000;
      return WyUtils.toNiceTimeFormat(seconds);
    },

    formatterNumber(value) {
      return WyUtils.formatterNumber(value);
    },

    async startLoading() {
      this.initDate = new Date();
      if (!this.loading) {
        this.logEventLoaded();
      }
      await this.loadTagCategories();
    },

    logEventLoaded() {
      if (this.initDate) {
        this.initDate = null;
      }
    },

    toTranscriptLabel(val) {
      return WyUtils.toTranscriptLabel(val);
    },

    formatMessageDate(date) {
      return WyUtils.formatDate(date);
    },

    formatMessageHeaderDate(date) {
      return WyUtils.formatDateWithDay(date);
    },

    getTimeRange(transcript) {
      if(transcript.startDateTime && transcript.endDateTime) {
        let sTime = WyUtils.dateTimeValidation(transcript.startDateTime)
        let eTime = WyUtils.dateTimeValidation(transcript.endDateTime)
        let startTime = moment(sTime).format("h:mm a");
        let endTime = moment(eTime).format("h:mm a");
        return startTime + ' - ' + endTime;
      }
      else {
        return 'Invalid time';
      }
    },

    async getPhrasesByCategory(category) {
      this.showPhraseContent = false;
      this.topicPhraseHitsCategories.map(el => { el.selected = false });
      if (category) category.selected = true;
      this.topicPhraseHits = [];
      this.showTranscriptContent = false;
      this.loadingPhrases = true;
      this.loadingMsg = true;
      const result = await this.fetchAssociatedTopicPhraseHitByCategoryName({
        tagId: this.tagData.tagId,
        categoryName: category.categoryName
      })
      if (result && result.data && result.data.length > 0) {
        this.selectedCategory = category.categoryName;
        await this.getContactsByCategoryPhrase(category.categoryName, result.data[0], 0);
        this.topicPhraseHits = result.data;
        this.topicPhraseHitsList.map(el => { el.selected = false });
        result.data[0].selected = true;
        this.showTranscriptContent = true;
      }
      else {
        this.topicPhraseHits = [];
        this.showTranscriptContent = false;
      }
      this.loadingPhrases = false;
      this.showPhraseContent = true;
    },
    
    handleOpenMediaPlayer(conversationId) {
      if(this.tokenInfo && this.tokenInfo.authHost) {
        const mediaLink = `https://${this.tokenInfo.authHost}/#/recordings/${conversationId}/ccr`
        window.open(mediaLink);
      }
    },

    async getContactsByCategoryPhrase(categoryName, phrase, pageNo) {
      this.showMessageContent = false;
      this.topicPhraseHitsList.map(el => { el.selected = false });
      if (phrase) phrase.selected = true;
      if (pageNo) {
        this.pageNo = pageNo;
      }
      else {
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
        this.pageCount = 1;
      }
      
      this.topicMessages = [];
      this.showTranscriptContent = false;

      this.loadingMsg = true;
      const result = await this.fetchAssociatedTopicPhraseHitContacts({ 
        tagId: this.tagData.tagId,
        categoryName: categoryName,
        phraseName: phrase.phraseName, 
        pageNo: this.pageNo, 
        pageSize: this.pageSize + 1, 
      })
      if (result && result.data && result.data.length > 0) {
        if (result.data.length > this.pageSize) {
          this.topicMessages = result.data
          this.pageItemStart = (this.pageNo - 1) * (this.pageSize + 1) + 1;
          this.pageItemEnd = this.pageItemStart + this.pageSize;
          this.pageCount = this.pageNo + 1;
        }
        else {
          this.topicMessages = result.data;
          this.pageItemStart = (this.pageNo - 1) * (this.pageSize + 1) + 1;

          this.pageItemEnd = this.pageItemStart + result.data.length - 1;
        }
      }
      else {
        this.topicMessages = [];
        this.showTranscriptContent = false;
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
      }
      this.loadingMsg = false;
      setTimeout(() => {
        this.showMessageContent = true;
      }, 300);
    },

    async loadTagCategories() {
      if (this.fetchData && this.parent.currentItem) {
        this.showCategoriesContent = false;
        this.showPhraseContent = false;
        this.loadingCategories = true;
        this.loadingMsg = true;
        this.fetchData = false;
        this.showMessageContent = false;
        this.showTranscriptContent = false;
        this.showPhraseContent = false;
        this.tagData = this.parent.currentItem;

        const result = await this.fetchAssociatedTopicPhraseHitCategories({ 
          tagId: this.tagData.tagId
        })
        if (result.data && result.data.length > 0) {
          this.topicPhraseHitsCategories = result.data;
          this.getPhrasesByCategory(this.topicPhraseHitsCategories[0], 0);
        }
        else {
          this.topicPhraseHitsCategories = [];
        }
        this.loadingCategories = false;
        this.showCategoriesContent = true;
      }
      this.parent.stopLoadingByTab('groupedTopics');
    },

    updateCurrentRow() {
      this.parent.tableModel.results.forEach((row) => {
        if (row.topicDisplayName == this.parent.currentItem.topicDisplayName) {
          this.parent.currentItem = row;
        }
      })
    },
    mouseover(e, tooltips) {
      e.stopPropagation();
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.classList.add('black-background');
        tooltipsEl.classList.add('bottom-arrow');
        tooltipsEl.innerHTML = this.formatterNumber(tooltips);
        tooltipsEl.style.display = 'block';
        tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
        tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height - 55}px`;
        tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width / 2 + e.target.getBoundingClientRect().width / 2 + 25}px`;
      }
    },
    mouseout(e) {
      e.stopPropagation();
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
        tooltipsEl.classList.remove('bottom-arrow');
      }
    }
  },

  async created() {
    this.loadTagCategories();
  }
});
</script>

<style lang="scss">
.wy-smart-tag-dashboard-table-detail-associated-phrase-hit {
  display: inline-flex;
  width: 100%;
  height: calc(100vh - 287px);
  // min-width: 1093px;
  min-width: 1176px;

  .main-panel-content {
    display: inline-flex;
    width: 100%;
  }
  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }


  .sentiment-icon-positive {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-neutral {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-negative {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .phrase-categories-section {
    min-width: 305px !important;
    max-width: 305px!important;
    width: 25%
  }

  .topic-group-section, .phrase-categories-section {
    min-width: 540px;
    // max-width: 540px;
    margin-right: 15px;
    margin-bottom: 20px;
    width: 50%;
    padding: 10px 0px 10px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    opacity: 1;

    .div-content {
      margin-top: 10px;
      border-top: 1px solid #E8E8E8;
      height: calc(100vh - 355px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 12px;

      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8;
        border-top: 1px solid #CAD2DA;
        border-bottom-right-radius: 8px !important;

      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        // border-left: 1px solid #CAD2DA;
        border-top: none !important;
      }

    }

    .div-phrase-categories-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 5px 30px;
    }
    .div-phrases-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 5px 30px;
    }
    .div-smart-tag-contacts-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 5px 30px;
    }

    .div-phrase-categories {
      margin-top: 0px;

      .div-phrase-categories-content {
        height: fit-content;

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 19px;
          padding: 9px 20px 3px 30px;
          font-size: 12px;
          // width: 88%;
          white-space: nowrap;
          overflow: hidden;
          // text-overflow: ellipsis;
          cursor: pointer;

          .div-ellipsis-item {
            width: calc(100% - 100px);
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
          }
          .div-total {
            display: inline-block;
            width: 50px;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
          }

          button {
            width: 15px;
            height: 15px;
            border: 0;
            padding: 0;
            margin: 0;
            background-color: #fff;

            .el-icon-error {
              top: -3px;
            }
          }
        }

        .div-item:hover {
          background: #f5f7fa;
        }

        .div-item.selected {
          background: #E2ECF7;

          button {
            background-color: #E2ECF7;
          }
        }

        .div-item.disabled {
          button {
            opacity: 0.3 !important;
            cursor: default;

            .el-icon-error {
              cursor: default;
            }
          }
        }

        .el-icon-error {
          float: right;
          // display: none;
          top: 2px;
          position: relative;
          color: #80A6CD;
          cursor: pointer;
          font-size: 15px;
        }

        .el-icon-error.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .div-item:hover .el-icon-error {
          display: block;
        }
      }
      
      .div-no-data {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        color: #ADADAD;
        background-image: url('../../assets/brands/st/icons/icon_smart_tags_no-data.png');
        background-size: 100%;
        background-repeat: no-repeat;
        height: 200px;
      }
    }
    .div-phrase-categories.categories {
      .div-no-data {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        color: #ADADAD;
        background-size: 100%;
        background-repeat: no-repeat;
        height: 200px;
      }
    }
    .div-phrase-categories.phrases {
      .div-no-data {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        color: #ADADAD;
        background-size: 100%;
        background-repeat: no-repeat;
        height: 200px;
        width: 300px;
      }
    }
    .div-phrase-categories.phrases.no-data {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      height: calc(100% - 100px);
    }
    .div-phrase-categories.contacts {
      .div-no-data {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        color: #ADADAD;
        background-size: 100%;
        background-repeat: no-repeat;
        height: 500px;
      }
    }
    .el-loading-parent--relative {
      height: calc(100% - 60px) !important;
    }
  }

  .smart-tag-contacts-section {
    margin-bottom: 20px;
    margin-right: 15px;
    width: 100%;
    // min-width: 310px;
    min-width: 280px;
    // max-width: 310px;
    padding: 7px 0px 10px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;

    .el-loading-mask {
      height: unset !important;
      opacity: unset;
      background-color: unset;

      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;
      }

      .el-loading-spinner .circular {
        display: unset !important;
      }
    }

    .div-smart-tag-contacts-header {
      font-size: 16px;
      font-weight: 500;
      padding: 4px 10px 9px 30px;
    }

    .div-smart-tag-contacts-content {
      margin-top: 5px;
      border-top: 1px solid #E8E8E8;
      border-bottom: 1px solid #E8E8E8;
      height: calc(100vh - 384px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 5px;
      //padding-top: 10px;

      .div-topic-message-name {
        font-size: 12px;
        word-break: keep-all;
        // cursor: pointer;
        color: var(--site-font-primary-color);
        font-weight: normal;
        margin: 0px 0px 0px 0px;
        line-height: 12px;
        padding: 12px 15px 11px 30px;

        .div-item-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          display: flex;
          padding: 15px 0px;
          justify-content: space-between;

          .col-left,.col-right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 40px;
          }

          .message-contact-id {
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            cursor: pointer;
            text-decoration-line: underline;
            text-decoration-style: solid;
          }
          .message-date {
            width: 105px;
            display: inline-block;
          }

          .message-contact-name {
            font-weight: 500;
            text-align: right;
          }

          .message-right {
            float: right;
            width: 130px;

            .message-date-time {
              text-align: left;
              padding-right: 10px;
            }
          }
        }
      }

      .div-topic-message-name:hover {
        // background: #f5f7fa;
        background: #E2ECF7;
      }

      .div-topic-message-name.selected {
        background: #E2ECF7;
      }
      
      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8;
        border-top: 1px solid #CAD2DA;
      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        // border-left: 1px solid #CAD2DA;
        border-top: none !important;
      }

    }
    .div-no-data {
      display: flex;
      width: 100%;
      height: calc(100% - 100px);
      justify-content: space-around;
      border-top: 1px solid #E8E8E8;
      margin-top: 5px;
      padding-top: 16px;
      align-items: center;
      .no-data-message {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        // color: #ADADAD;
        background-image: url('../../assets/brands/st/icons/icon_smart_tags_no-data.png');
        background-size: 100%;
        background-repeat: no-repeat;
        height: 200px;
        width:300px;
      }
    }
    .el-loading-parent--relative {
      height: calc(100% - 60px) !important;
      border-top: 1px solid #E8E8E8;
      margin-top: 5px;
    }
  }

  .message-transcripts-section {
    padding: 7px 0px 0px 0px;
    margin-bottom: 20px;
  }

  .div-group-viewer-footer.div-group-name {
    font-size: 16px;
    font-weight: 500;
    padding: 0px 0px 0px 0px;
  }

  .div-message-transcripts-viewer-footer {
    display: inline-block;
    width: 100%;

    .div-transcript-page-infor {
      float: left;
      padding-top: 2px;
      padding-left: 14px;
      font-size: 12px;
      color: #ADADAD;
    }

    .div-transcript-pagination {
      float: right;
      padding-right: 14px;
      font-size: 12px;
      color: #ADADAD;

      .el-pagination {
        padding-right: 0px;
      }

      .el-pagination button {
        color: #002852;
        font-weight: bold;
        padding-right: 0px;
        padding-left: 30px;
        font-size: 12px;
        line-height: unset !important;
        height: unset !important;

        >span {
          line-height: unset !important;
          height: unset !important;
        }
      }

      .el-pagination button.btn-next {
        padding-left: 10px;
      }

      .el-pagination button:disabled {
        color: #C0C4CC;
      }

      .el-pagination span:not([class*=suffix]) {
        word-spacing: 7px;
      }
    }
  }
  .main-panel.div-no-data {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-around;
    align-items: center;
    .no-data-message {
      text-align: center;
      padding: 20px 0;
      font-size: 14px;
      // color: #ADADAD;
      background-image: url('../../assets/brands/st/icons/icon_smart_tags_no-data.png');
      background-size: 100%;
      background-repeat: no-repeat;
      height: 500px;
      width: 400px;
    }
  }
}

.site-tooltips.bottom-arrow:after {
  transform: rotateZ(180deg);
  bottom: 0%;
  top: 95%;
  left: 20% !important;
}
</style>